module.exports = __webpack_public_path__ + "static/img/logo-trade.8078f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-trade.png
// module id = A1vj
// module chunks = 67